import { Spinner } from 'react-bootstrap';
import './LoadingSpinner.css';

export default function LoadingSpinner({ color = '#0d6efd' }) {
  return (
    <div className="loading-spinner-container">
      <Spinner animation="border" role="status" className="loading-spinner" style={{ color }}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}
